export enum NotificationIcons {
  success = 'fas fa-check',
  warning = 'fas fa-exclamation-triangle',
  error = 'fas fa-times',
  info = 'fas fa-exclamation',
  file = 'far fa-file',
  appointment = 'fas fa-calendar-alt',
}
